import React from "react";

const Contact = () => {
  return (
    <div>
      <div className="container">
        <h4 className="center">Contact Us</h4>
        <p>
          All new enquiries or current queries/complaints/questions/feedback
          about anything at all please contact the General Secretary, Sarah.
        </p>
        <a href="mailto:general.secretary.mwrl@gmail.com">
          general.secretary.mwrl@gmail.com
        </a>

        <p>
          She will then discuss anything with the relevant committee members so
          things get dealt with in a fair and efficient way.
        </p>

        <hr />

        <p>
          All team sheets and overall scores go to the Summer Secretary, Emily.
        </p>
        <a href="mailto:Summer.secretary.mwrl@gmail.com">
          Summer.secretary.mwrl@gmail.com
        </a>

        <p>
          She will then upload these and they will be shown on the Fixtures
          page. The overall league tables will be shared via Fixtures Live, and
          also a tally of the top 10 scorers throughout the season.
        </p>

        <p>
          New player registrations must be EMAILED to Emily by the
          captain/vice-captain BEFORE your match commences - if new players
          aren't registered their rounders will not count towards the overall
          score or their individual tally!
        </p>

        <hr />

        <p>
          The Summer Ladies Coordinator is Phoebe - she will be in contact if
          there are any messages regarding the ladies season that need to go to
          all captains/teams.
        </p>
        <a href="mailto:Summer.ladies.coordinator@gmail.com">
          Summer.ladies.coordinator@gmail.com
        </a>

        <hr />

        <p>
          The Summer Mixed Coordinator is Mel - she will be in contact if there
          are any messages regarding the mixed season that need to go to all
          captains/teams.
        </p>

        <p>
          She will also collect payment from mixed league teams on a Thursday
          evening.
        </p>
        <a href="mailto:Summer.mixed.coordinator@gmail.com">
          Summer.mixed.coordinator@gmail.com
        </a>

        <hr />

        <p>
          The Rules Coordinator is Katy - she will be in contact if there are
          any rules that need to be shared with everyone, and will provide
          clarification where required.
        </p>
        <a href="mailto:Rules.mwrl@gmail.com">Rules.mwrl@gmail.com</a>

        <hr />

        <p>
          The League Chair is Georgie - she will be in contact regarding
          anything that involves the entire league. She also provides support to
          all the above committee members to help ensure that the season runs as
          smoothly as possible.
        </p>
        <a href="mailto:Chair.mwrl@gmail.com">Chair.mwrl@gmail.com</a>
        <br />
        <br />
      </div>
    </div>
  );
};

export default Contact;
